import { html } from "lit";

export const iconTeaserData = {
    title: "Medienpool",
    icon: "calendar",
    variant: "",
    class: "",
    text: "",
};

export const IconTeaserTemplate = (args = iconTeaserData) => {
    return html`
        <ux-iws-teaser-icon
            variant="${args.variant}"
            icon-name="${args.icon}"
            shadow="${args.variant !== "" ? true : false}"
            class="${args.class}"
        >
            <div
                slot="title"
                class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                data-same-height="title"
            >
                <strong>${args.title}</strong>
            </div>
            ${args.text
                ? html`<div
                      slot="text"
                      data-same-height="copy-text"
                      class="text-tiny"
                  >
                      <p>${args.text}</p>
                  </div> `
                : html``}
            <div slot="link">
                <a href="#" class="ux-text-link ux-text-link--green">
                    Mehr erfahren<ux-icon name="arrow-small-right"
                /></a>
            </div>
        </ux-iws-teaser-icon>
    `;
};
